import React from "react";
import { Image, Tag } from "antd";
import PinnedLogo from "../../../../icons/svg/pinned.svg";
import { openDrawer, updateDrawer } from "../../../../library/helpers";
import { DRAWER_TYPES } from "../../../hoc/Drawer/drawer";
import CustomButton from "../../../commonComponents/button";
import NotesPreferences from "./NotesPreferences";

const PinnedMessageTag = ({ messageNotesCount, messageId, messageContent, messageType, user }) => {
  const handleClick = () => {
    // Function to handle the "Add new note" button click
    const handleAddNewNote = () => {
      // Update the drawer with showAddNoteForm: true to trigger re-render
      updateDrawer({ showAddNoteForm: true });
    };

    // preferences are handled inside NotesPreferences; we will receive state via callback
    const handlePrefsChange = nextSettings => {
      // push preferences into the drawer state so the drawer content can access them
      updateDrawer({ preferences: nextSettings });
    };

    openDrawer(
      DRAWER_TYPES.VIEW_MESSAGE_NOTES,
      {
        title: (
          <div className="flex items-center justify-between">
            <p>Message note</p>
            <div className="flex items-center gap-2">
              <CustomButton btnText="Add new note" handleClick={handleAddNewNote} type="primary" />
              <NotesPreferences onChange={handlePrefsChange} />
            </div>
          </div>
        ),
      },
      {
        messageId: messageId,
        messageContent: messageContent,
        messageType: messageType,
        messageNotesCount: messageNotesCount,
        user: user,
        showAddNoteForm: false, // Initial state
        showSettings: false, // Initial state
      }
    );
  };

  return (
    <Tag
      color="#FEF9C2"
      onClick={handleClick}
      className="flex !py-1 !px-2 !h-5 !me-0 md:!me-2 border cursor-pointer border-solid border-[#FFF089] gap-1 items-center rounded-full"
    >
      <Image src={PinnedLogo} preview={false} className="!mb-[2px]" />
      <span className="text-xs font-normal text-black/[0.88]">
        {messageNotesCount === 1 ? "Message Note" : `${messageNotesCount} Message Notes`}
      </span>
    </Tag>
  );
};

export default PinnedMessageTag;
